import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=3b886391&scoped=true&"
import script from "./custom.js?vue&type=script&lang=js&"
export * from "./custom.js?vue&type=script&lang=js&"
import style0 from "./custom.css?vue&type=style&index=0&id=3b886391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b886391",
  null
  
)

export default component.exports